"use client"

import React from 'react'
import { motion } from 'framer-motion'
import { Button } from '@sarkiai/ui'
import { VCardDetail as VCardDetailComponent } from '@/components/home/VCardDetail'
import { Shield, Zap, RefreshCw, BarChart, Smartphone, ArrowRight } from 'lucide-react'
import { useTranslations } from '@/components/I18nProvider'
import Link from 'next/link'

export default function VCardPage() {
  const t = useTranslations('vcard_page')

  const benefits = [
    { icon: Shield, title: t('benefits.b1_title'), desc: t('benefits.b1_desc') },
    { icon: RefreshCw, title: t('benefits.b2_title'), desc: t('benefits.b2_desc') },
    { icon: BarChart, title: t('benefits.b3_title'), desc: t('benefits.b3_desc') },
    { icon: Smartphone, title: t('benefits.b4_title'), desc: t('benefits.b4_desc') },
  ]

  return (
    <div className="min-h-screen bg-background pt-20">
      {/* Detail Section as Hero */}
      <VCardDetailComponent />

      {/* Benefits Grid */}
      <section className="py-24 bg-black text-white px-4 lg:px-12">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {benefits.map((b, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
                className="p-10 rounded-[2.5rem] border border-white/10 bg-white/5 hover:bg-white/[0.07] hover:border-white/20 transition-all duration-500 group"
              >
                <div className="w-16 h-16 rounded-2xl bg-white text-black flex items-center justify-center mb-8 shadow-lg shadow-white/10 transition-transform group-hover:scale-110">
                  <b.icon className="w-8 h-8" />
                </div>
                <h3 className="text-xl  uppercase tracking-tight mb-4 text-white">{b.title}</h3>
                <p className="text-white/60 text-sm leading-relaxed">{b.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-24 md:py-32 bg-black dark:bg-white text-white dark:text-black px-4 lg:px-12">
        <div className="container mx-auto text-center space-y-10 group">
          <h2 className="text-4xl md:text-5xl uppercase tracking-tighter leading-none">
            {t('cta.title')}
          </h2>
          <p className="text-xl md:text-2xl opacity-80 max-w-3xl mx-auto leading-relaxed">
            {t('cta.subtitle')}
          </p>
          <div className="flex flex-wrap justify-center gap-6">
            <Button size="default" className="rounded-2xl px-8 h-12 text-sm bg-white dark:bg-black text-black dark:text-white hover:bg-black dark:hover:bg-white hover:text-white dark:hover:text-black font-bold uppercase tracking-widest transition-all shadow-xl">
              <Link href="/contact" className="flex items-center justify-center gap-2">
                {t('cta.order')}
                <ArrowRight className="ml-2 w-5 h-5" />
              </Link>
            </Button>
          </div>
        </div>
      </section>
    </div>
  )
}
